
<div class="pa-2 pl-4 select-item v-flex" :class="selected ? selectedColor : 'unselected'" style="min-height: 34px;">
    <div style="width: 25px; min-width: 25px;">
        {{ index }}.
    </div>
    <div>
        {{ item.name}}
    </div>
</div>
